import { createSelector } from '@ngrx/store';
import {
	FileEntitySelector,
	IFileState,
} from '@app/pages/cmms/components/files/state/files.reducer';
import { AuUtilsFunctions } from '@app/shared';

import {
	defaultPageSize,
	paginationQueryVariables,
} from '@app/pages/cmms/configs/pagination-query-variables';

export const selectFileState = state => state.cmms.fileState;

export const filesAuPagination = createSelector(selectFileState, (state: IFileState) => {
	return state.filesAuPagination;
});

export const filesPageSize = createSelector(
	selectFileState,
	(state: IFileState) =>
		state.filesAuPagination?.first ?? state.filesAuPagination?.last ?? defaultPageSize
);

export const filesQueryVariables = createSelector(
	selectFileState,
	(state: IFileState) => state.filesQueryVariables
);

export const filesQueryVariablesWithoutPagination = createSelector(
	selectFileState,
	(state: IFileState) => {
		if (state.filesQueryVariables) {
			return AuUtilsFunctions.excludeObjectKeys(
				state.filesQueryVariables,
				paginationQueryVariables
			);
		}
	}
);

export const filesTableColumnKeys = createSelector(
	selectFileState,
	(state: IFileState) => {
		return (state.tableColumnsConfig ?? []).map(column => column.key);
	}
);

export const filesTableExportUrlQuery = createSelector(
	selectFileState,
	(state: IFileState) => state.exportUrlQuery
);

export const filesIsExportable = createSelector(
	selectFileState,
	(state: IFileState) => state.isExportable
);

export const filesExportTableData = createSelector({
	isExportable: filesIsExportable,
	queryVariables: filesQueryVariablesWithoutPagination,
	columnKeys: filesTableColumnKeys,
	exportUrlQuery: filesTableExportUrlQuery,
});

export const isLoadingFiles = createSelector(
	selectFileState,
	(state: IFileState) => state.isLoadingFiles
);

export const allFiles = createSelector(selectFileState, (state: IFileState) => {
	return {
		files: FileEntitySelector.selectAll(state),
		filePagination: state.filesPagination,
	};
});

export const totalFiles = createSelector(selectFileState, FileEntitySelector.selectTotal);

export const editingFile = createSelector(
	selectFileState,
	(state: IFileState) => state.fileEdit
);

export const replacingInProgress = createSelector(
	selectFileState,
	(state: IFileState) => state.replacingInProgress
);

export const selectDetectionTaskResult = createSelector(
	selectFileState,
	(state: IFileState) => state.detectionTaskResults
);

export const selectActiveTab = createSelector(
	selectFileState,
	(state: IFileState) => state.fileActiveTab
);

export const fileQueryVariables = createSelector(
	selectFileState,
	(state: IFileState) => state.filesQueryVariables
);
